import React from 'react';
import { BenefitPaper } from '../../component/benefitTabs/BenefitPaper';
import { useBikeleasingPrecondition } from '../../module/benefits/bikeleasingV2/useBikeleasingPrecondition';
import {
  BenefitPayrollPreconditionExtensionInterface,
  PayrollPreconditionGateProps,
} from '../interface/benefit-payroll-precondition.extension.interface';

const BikeleasingPayrollPreconditionGate: React.FC<PayrollPreconditionGateProps> = ({ children }) => {
  const { isPreconditionMet, PreconditionComponent } = useBikeleasingPrecondition();

  if (!isPreconditionMet) {
    return <BenefitPaper>{PreconditionComponent}</BenefitPaper>;
  }

  return <>{children}</>;
};

export class BikeleasingBenefitPayrollPreconditionExtension extends BenefitPayrollPreconditionExtensionInterface {
  PreconditionGate = BikeleasingPayrollPreconditionGate;
}
